import ReactDOM from "react-dom";
import { useState } from "react";
import Button from "../../../common/Button";
import { completeTransferRequest } from "../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import { getLocationNameFromId } from "../../../../lib/labels";

export default function TransferClinicComplete({practiceData, status}) {
    const dispatch = useDispatch()
    const [loading, isLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const pendingTransfer = practiceData.case_practice_transfers?.find(item => item.status == status)

    function openModalHandler() {
        setShowModal(true)
    }

    function closeModalHandler() {
        setShowModal(false)
    }

    async function completeTransferHandler() {
        isLoading(true)
        let reqBody = {
            case_practice_id: pendingTransfer?.case_practice_id,
            case_practice_transfer_id: pendingTransfer?.id
        }

        let completeTransfer = await completeTransferRequest(userToken, activeCase.case.id, reqBody, dispatch)
        if (completeTransfer && completeTransfer.errorMessage) {
            dispatch(notificationActions.setError(completeTransfer))
        } else {
            dispatch(notificationActions.setError({errorMessage: `Transfer Completed!`, type: 'success'}))

            let dispatchBody = {
                case_practice_id: practiceData.id,
                item: completeTransfer
            }
            dispatch(caseActions.updateTransfersOnPractices(dispatchBody))
            closeModalHandler()
        }

        isLoading(false)
    }

    return <>
        <Button btnStyle={'btn_simple'} title={'Complete transfer'} click={openModalHandler} isLoading={loading}>
            <i className="ti ti-home-check" style={{color: 'var(--green1)'}}></i>
        </Button>

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop />,
                document.getElementById("backdrop-root")
            )}
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Complete Transfer'}>
                        <PannelBody>
                            <p>This will mark the transfer as completed. The patient will remain at {getLocationNameFromId(pendingTransfer?.to_location_id)}.</p>
                        </PannelBody>
                        <PannelBody>
                            <div className="flex-container">
                                <Button click={completeTransferHandler} isLoading={loading}>Ok</Button>
                            </div>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}
        </>}
    </>
}
